import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";
import { HeroStack } from "./HeroStack";
import { WaitlistForm } from "./WaitlistForm";

const fade = (d) => ({
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay: d, ease: [0.16, 1, 0.3, 1] },
});

export const Hero = () => (
  <section id="top" className="relative overflow-hidden pt-28 sm:pt-36 pb-20 lg:pb-28" data-testid="hero-section">
    <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.035)_1px,transparent_1px)] bg-[size:72px_72px] [mask-image:radial-gradient(ellipse_at_top_left,black,transparent_70%)]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
      <div className="lg:col-span-7">
        <motion.p {...fade(0.1)} className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300" data-testid="hero-badge">
          <span className="h-2 w-2 rounded-full bg-[#FF3838] blink" /> The urgent marketplace
        </motion.p>
        <h1 className="font-display font-black tracking-tight leading-[0.95] text-[12vw] sm:text-7xl lg:text-[4.6rem] xl:text-[5.2rem]" data-testid="hero-title">
          <MaskLines lines={["Sell it", "today."]} delay={0.2} />
          <MaskLines lines={["Buy it", "first."]} delay={0.45} lineClass="text-[#FF3838]" />
        </h1>
        <motion.p {...fade(0.9)} className="mt-8 max-w-lg text-base md:text-lg text-zinc-300 leading-relaxed" data-testid="hero-subtitle">
          UrgentSellBuy connects people who need to sell fast with buyers ready to move now. No endless haggling. No dead listings. Just deals with a deadline.
        </motion.p>
        <motion.div {...fade(1.05)} className="mt-10 max-w-lg">
          <WaitlistForm testPrefix="hero" />
        </motion.div>
      </div>
      <div className="lg:col-span-5">
        <HeroStack />
      </div>
    </div>
  </section>
);
